import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-111864c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "section border-b" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "section-title" }, "Información de la empresa", -1))
const _hoisted_5 = { class: "flex lg:flex-row flex-col gap-4" }
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "section-title" }
const _hoisted_8 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_9 = { class: "section border-t border-b" }
const _hoisted_10 = { class: "section-title" }
const _hoisted_11 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_12 = { class: "section border-b" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "section-title" }, "Información bancaria", -1))
const _hoisted_14 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_15 = {
  key: 0,
  class: "section"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "section-title" }, "Información personería", -1))
const _hoisted_17 = { class: "flex gap-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "flex text-sm font-semibold pb-1",
  for: "datepicker"
}, " Fecha de la escritura ", -1))
const _hoisted_19 = { class: "m-2" }
const _hoisted_20 = ["disabled"]

import { computed, watch, ref, onMounted } from "vue";
import router from "@/router";
import { storeToRefs } from "pinia";

import Swal from "sweetalert2";

import { bankAccountTypes, UserFetchData } from "@/services/auth/types";
import { useShareholderStore } from "@/stores/shareholder";
import { AuthService } from "@/services/auth/AuthService";
import {
  isNullOrEmpty,
  reformatDateISO8601,
  validateRut,
} from "@/services/utils";

import useBankStore from "@/stores/banks";

import Datepicker, { VueDatePicker } from "@vuepic/vue-datepicker";

import TextField from "@/components/atoms/TextField.vue";
import Selector from "@/components/atoms/Selector.vue";
import SelectorSimpler from "@/components/atoms/SelectorSimpler.vue";
import ChangePasswordForm from "@/components/molecules/ChangePasswordForm.vue";

type userResponse = {
  detail: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareholderIdentificationTab',
  setup(__props) {

const bankStore = useBankStore();
const authService = new AuthService();

const { bankListable: banks } = storeToRefs(bankStore);

const shareholderStore = useShareholderStore();
const { shareholder } = storeToRefs(shareholderStore);

const showChangePasswordModal = ref<boolean>(false);

const changed = ref<boolean>(false);

const flow = ref<VueDatePicker["flow"]>(["month", "calendar"]);

const shareholderId = computed(() =>
  Number(router.currentRoute.value.params.id)
);

const investorNumberA = ref<number | null>(null);
const investorNumberB = ref<number | null>(null);

const rutFieldHasError = computed(() => {
  if (shareholder.value == undefined) return true;
  return (
    isNullOrEmpty(shareholder.value.rut) || !validateRut(shareholder.value.rut)
  );
});

async function setWritingDate(date: string) {
  if (shareholder.value == undefined) return;
  shareholder.value.writingDate = reformatDateISO8601(new Date(date));
}

async function submitUser() {
  if (shareholder.value == undefined || rutFieldHasError.value) {
    return;
  }
  // investorNumberA.value = investorNumberA.value ? investorNumberA.value : null;
  // investorNumberB.value = investorNumberB.value ? investorNumberB.value : null;
  let userFetchData = new UserFetchData(
    shareholder.value.firstName,
    shareholder.value.lastName,
    shareholder.value.rut,
    shareholder.value.email,
    shareholder.value.phone,
    shareholder.value.address,
    shareholder.value.bankName,
    shareholder.value.bankCode,
    shareholder.value.accountType,
    shareholder.value.accountNumber,
    shareholder.value.accountOwnerName,
    shareholder.value.accountOwnerRut,
    shareholder.value.accountEmail,
    shareholderId.value,
    shareholder.value.county,
    shareholder.value.region,
    shareholder.value.investorNumberA ? null : investorNumberA.value,
    investorNumberB.value == shareholder.value?.investorNumberB
      ? null
      : investorNumberB.value,
    0,
    0,
    0,
    shareholder.value.businessName ?? "",
    shareholder.value.businessAddress ?? "",
    shareholder.value.businessRut ?? "",
    shareholder.value.writingDate ?? null,
    shareholder.value.notary ?? "",
    shareholder.value.notaryCity ?? "",
    shareholder.value.repertoireNumber ?? ""
  );
  const response = await authService.editShareholder(userFetchData);
  if (response.success) {
    shareholderStore.query(shareholderId.value);
    Swal.fire(
      "¡Listo!",
      "La información se ha modificado de forma éxitosa",
      "success"
    );
  } else {
    const responseData = response.data as userResponse;
    Swal.fire("¡Error!", responseData.detail, "error");
  }
}

watch(
  shareholder,
  (newShareholder) => {
    if (newShareholder) {
      investorNumberA.value = newShareholder.investorNumberA
        ? newShareholder.investorNumberA
        : 0;
      investorNumberB.value = newShareholder?.investorNumberB
        ? newShareholder?.investorNumberB
        : 0;
    }
  },
  { immediate: true }
);

onMounted(() => {
  bankStore.fetchBanks();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(shareholder))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(TextField, {
                class: "flex-1",
                model: _unref(shareholder).businessName,
                "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_unref(shareholder).businessName) = $event)),
                type: "text",
                name: "company",
                label: "Razón social",
                "has-error": false,
                "error-message": "'Error'",
                "hide-details": "",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"]),
              _createVNode(TextField, {
                class: "flex-1",
                model: _unref(shareholder).businessAddress,
                "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_unref(shareholder).businessAddress) = $event)),
                type: "text",
                name: "address",
                label: "Dirección",
                "has-error": false,
                "error-message": "'Error'",
                "hide-details": "",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"]),
              _createVNode(TextField, {
                model: _unref(shareholder).businessRut,
                "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((_unref(shareholder).businessRut) = $event)),
                type: "text",
                name: "",
                label: "Rut",
                "has-error": rutFieldHasError.value,
                "error-message": "El rut no es válido o no se encuentra en el formato indicado (Ej: 12345678-9)",
                "hide-details": "",
                onChange: _cache[5] || (_cache[5] = ($event: any) => (changed.value = true))
              }, null, 8, ["model", "has-error"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, _toDisplayString(_unref(shareholder).businessName
              ? "Información del representante legal"
              : "Información del accionista"), 1),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(TextField, {
                class: "lg:col-span-1 col-span-4",
                model: _unref(shareholder).firstName,
                "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((_unref(shareholder).firstName) = $event)),
                type: "text",
                name: "firstName",
                label: "Nombre",
                "has-error": false,
                "error-message": "Nombre no valido",
                "hide-details": "",
                onChange: _cache[7] || (_cache[7] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"]),
              _createVNode(TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _unref(shareholder).lastName,
                "onUpdate:model": _cache[8] || (_cache[8] = ($event: any) => ((_unref(shareholder).lastName) = $event)),
                type: "text",
                name: "lastName",
                label: "Apellido",
                "has-error": false,
                "error-message": "Apellido indicado no es valido",
                "hide-details": "",
                onChange: _cache[9] || (_cache[9] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"]),
              _createVNode(TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _unref(shareholder).rut,
                "onUpdate:model": _cache[10] || (_cache[10] = ($event: any) => ((_unref(shareholder).rut) = $event)),
                type: "text",
                name: "userRut",
                label: "Rut",
                "has-error": rutFieldHasError.value,
                "error-message": "El rut ingresado no es valido o no tiene un formato correcto (Ej: 12345678-9)",
                "hide-details": "",
                onChange: _cache[11] || (_cache[11] = ($event: any) => (changed.value = true))
              }, null, 8, ["model", "has-error"]),
              _createVNode(TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _unref(shareholder).address,
                "onUpdate:model": _cache[12] || (_cache[12] = ($event: any) => ((_unref(shareholder).address) = $event)),
                type: "text",
                name: "address",
                label: "Dirección particular",
                "has-error": false,
                "error-message": "La dirección ingresada no es valida",
                "hide-details": "",
                onChange: _cache[13] || (_cache[13] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"]),
              _createVNode(TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _unref(shareholder).county,
                "onUpdate:model": _cache[14] || (_cache[14] = ($event: any) => ((_unref(shareholder).county) = $event)),
                type: "text",
                name: "contry",
                label: "Comuna",
                "has-error": false,
                "error-message": "'Error'",
                "hide-details": "",
                onChange: _cache[15] || (_cache[15] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"]),
              _createVNode(TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _unref(shareholder).region,
                "onUpdate:model": _cache[16] || (_cache[16] = ($event: any) => ((_unref(shareholder).region) = $event)),
                type: "text",
                name: "region",
                label: "Región",
                "has-error": false,
                "error-message": "'Error'",
                "hide-details": "",
                onChange: _cache[17] || (_cache[17] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"]),
              _createVNode(TextField, {
                class: "col-span-4 lg:col-span-1",
                model: investorNumberA.value,
                "onUpdate:model": _cache[18] || (_cache[18] = ($event: any) => ((investorNumberA).value = $event)),
                type: "number",
                name: "investorNumberA",
                label: "ID A",
                "has-error": false,
                "error-message": "El número de accionista ingresado no es valido",
                "hide-details": "",
                onChange: _cache[19] || (_cache[19] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"]),
              _createVNode(TextField, {
                class: "col-span-4 lg:col-span-1",
                model: investorNumberB.value,
                "onUpdate:model": _cache[20] || (_cache[20] = ($event: any) => ((investorNumberB).value = $event)),
                type: "number",
                name: "investorNumberB",
                label: "ID B",
                "has-error": false,
                "error-message": "El número de accionista ingresado no es valido",
                "hide-details": "",
                onChange: _cache[21] || (_cache[21] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h5", _hoisted_10, _toDisplayString(_unref(shareholder).isBusiness ? "Datos de contacto" : "Datos de contacto"), 1),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _unref(shareholder).email,
                "onUpdate:model": _cache[22] || (_cache[22] = ($event: any) => ((_unref(shareholder).email) = $event)),
                type: "text",
                name: "",
                label: "Email",
                "has-error": false,
                "error-message": "El email no es correcto",
                "hide-details": "",
                onChange: _cache[23] || (_cache[23] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"]),
              _createVNode(TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _unref(shareholder).phone,
                "onUpdate:model": _cache[24] || (_cache[24] = ($event: any) => ((_unref(shareholder).phone) = $event)),
                type: "text",
                name: "phone",
                label: "Celular",
                "has-error": false,
                "error-message": "El número de telefono ingresado no es valido",
                "hide-details": "",
                onChange: _cache[25] || (_cache[25] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(SelectorSimpler, {
                class: "col-span-4 lg:col-span-1",
                label: "Banco",
                selected: _unref(shareholder).bankCode,
                items: _unref(banks),
                "onUpdate:model": _cache[26] || (_cache[26] = 
              (item) => {
                if (_unref(shareholder)) {
                  _unref(shareholder).bankCode = item?.key;
                  changed.value = true;
                }
              }
            )
              }, null, 8, ["selected", "items"]),
              _createVNode(Selector, {
                class: "col-span-4 lg:col-span-1",
                label: "Tipo de cuenta",
                model: _unref(shareholder).accountType,
                "onUpdate:model": [
                  _cache[27] || (_cache[27] = ($event: any) => ((_unref(shareholder).accountType) = $event)),
                  _cache[28] || (_cache[28] = ($event: any) => (changed.value = true))
                ],
                items: _unref(bankAccountTypes)
              }, null, 8, ["model", "items"]),
              _createVNode(TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _unref(shareholder).accountNumber,
                "onUpdate:model": _cache[29] || (_cache[29] = ($event: any) => ((_unref(shareholder).accountNumber) = $event)),
                type: "text",
                name: "accountNumber",
                label: "Número de cuenta",
                "has-error": false,
                "error-message": "El numero de cuenta no es valido",
                "hide-details": "",
                onChange: _cache[30] || (_cache[30] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"]),
              _createVNode(TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _unref(shareholder).accountOwnerName,
                "onUpdate:model": _cache[31] || (_cache[31] = ($event: any) => ((_unref(shareholder).accountOwnerName) = $event)),
                type: "text",
                name: "bankUserName",
                label: "Nombre del titular",
                "has-error": false,
                "error-message": "El nombre no es valido",
                "hide-details": "",
                onChange: _cache[32] || (_cache[32] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"]),
              _createVNode(TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _unref(shareholder).accountOwnerRut,
                "onUpdate:model": _cache[33] || (_cache[33] = ($event: any) => ((_unref(shareholder).accountOwnerRut) = $event)),
                type: "text",
                name: "",
                label: "Rut del titular",
                "has-error": false,
                "error-message": "Rut no valido o en formato incorrecto (Ej:12345678-9)",
                "hide-details": "",
                onChange: _cache[34] || (_cache[34] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"]),
              _createVNode(TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _unref(shareholder).accountEmail,
                "onUpdate:model": _cache[35] || (_cache[35] = ($event: any) => ((_unref(shareholder).accountEmail) = $event)),
                type: "text",
                name: "",
                label: "Email de notificación",
                "has-error": false,
                "error-message": "El email no es valido",
                "hide-details": "",
                onChange: _cache[36] || (_cache[36] = ($event: any) => (changed.value = true))
              }, null, 8, ["model"])
            ])
          ]),
          (_unref(shareholder).isBusiness)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", null, [
                    _hoisted_18,
                    _createVNode(_unref(Datepicker), {
                      flow: flow.value,
                      format: "dd/MM/yyyy",
                      locale: "es",
                      "model-value": _unref(shareholder).writingDate,
                      "onUpdate:modelValue": setWritingDate,
                      "input-class-name": "dp-custom-input",
                      clearable: false,
                      "enable-time-picker": false,
                      placeholder: "Fecha de cuando se otorgó la escritura pública",
                      "model-type": "yyyy-MM-dd",
                      cancelText: 'Cancelar',
                      selectText: 'Seleccionar'
                    }, null, 8, ["flow", "model-value"])
                  ]),
                  _createVNode(TextField, {
                    class: "flex-1",
                    model: _unref(shareholder).notary,
                    "onUpdate:model": _cache[37] || (_cache[37] = ($event: any) => ((_unref(shareholder).notary) = $event)),
                    type: "text",
                    name: "notary",
                    label: "Notaria",
                    "has-error": false,
                    "error-message": "no es valido",
                    "hide-details": "",
                    onChange: _cache[38] || (_cache[38] = ($event: any) => (changed.value = true))
                  }, null, 8, ["model"]),
                  _createVNode(TextField, {
                    class: "flex-1",
                    model: _unref(shareholder).notaryCity,
                    "onUpdate:model": _cache[39] || (_cache[39] = ($event: any) => ((_unref(shareholder).notaryCity) = $event)),
                    type: "text",
                    name: "notary",
                    label: "Ciudad de notaría",
                    "has-error": false,
                    "error-message": "no es valido",
                    "hide-details": "",
                    onChange: _cache[40] || (_cache[40] = ($event: any) => (changed.value = true))
                  }, null, 8, ["model"]),
                  _createVNode(TextField, {
                    class: "flex-1",
                    model: _unref(shareholder).repertoireNumber,
                    "onUpdate:model": _cache[41] || (_cache[41] = ($event: any) => ((_unref(shareholder).repertoireNumber) = $event)),
                    type: "text",
                    name: "repertoire_number",
                    label: "Número de repertorio",
                    "has-error": false,
                    "error-message": "El numero de repertorio no es valido",
                    "hide-details": "",
                    onChange: _cache[42] || (_cache[42] = ($event: any) => (changed.value = true))
                  }, null, 8, ["model"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("button", {
        class: "success w-36 btn ml-auto my-auto",
        disabled: !changed.value,
        onClick: submitUser
      }, " Guardar ", 8, _hoisted_20)
    ]),
    (showChangePasswordModal.value)
      ? (_openBlock(), _createBlock(ChangePasswordForm, {
          key: 1,
          visible: showChangePasswordModal.value,
          "onUpdate:visible": _cache[43] || (_cache[43] = ($event: any) => ((showChangePasswordModal).value = $event))
        }, null, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})